import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { Building2, Users, FileText, CreditCard, TrendingUp } from 'lucide-react';
import { formatCurrency } from '../../../lib/utils';

const STAT_CONFIG = [
    { key: 'total_agencies', label: 'Agences', icon: Building2, color: 'blue', format: (v) => v || 0 },
    { key: 'total_users', label: 'Utilisateurs', icon: Users, color: 'green', format: (v) => v || 0 },
    { key: 'total_mandates', label: 'Mandats', icon: FileText, color: 'purple', format: (v) => v || 0 },
    { key: 'total_signatures', label: 'Signatures', icon: CreditCard, color: 'orange', format: (v) => v || 0 },
    { key: 'estimated_mrr', label: 'MRR estimé', icon: TrendingUp, color: 'emerald', format: (v) => formatCurrency(v || 0) },
];

const COLOR_CLASSES = {
    blue: { bg: 'bg-blue-500/20', text: 'text-blue-400' },
    green: { bg: 'bg-green-500/20', text: 'text-green-400' },
    purple: { bg: 'bg-purple-500/20', text: 'text-purple-400' },
    orange: { bg: 'bg-orange-500/20', text: 'text-orange-400' },
    emerald: { bg: 'bg-emerald-500/20', text: 'text-emerald-400' },
};

function SuperAdminStatsGrid({ stats }) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            {STAT_CONFIG.map((cfg) => {
                const Icon = cfg.icon;
                const colors = COLOR_CLASSES[cfg.color];
                return (
                    <Card key={cfg.key} className="bg-gray-800 border-border">
                        <CardContent className="p-4">
                            <div className="flex items-center gap-3">
                                <div className={`w-10 h-10 rounded-lg ${colors.bg} flex items-center justify-center`}>
                                    <Icon className={`w-5 h-5 ${colors.text}`} />
                                </div>
                                <div>
                                    <p className="text-2xl font-bold">{cfg.format(stats?.[cfg.key])}</p>
                                    <p className="text-xs text-muted-foreground">{cfg.label}</p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                );
            })}
        </div>
    );
}

export default SuperAdminStatsGrid;
